// Flight-pad helpers — read normalized FlightOffer fields only
// (see providers/index.js typedef). Provider-agnostic.

import { count_adults } from '@liveflight/providers';
import {
  bag_quantity,
  guaranteed_bag_allowance,
} from '@liveflight/providers/base/helpers';

export const carrier_iata = (itinerary, segment_index = 0) => {
  const { segments = [] } = itinerary || {};
  const index = segments.length <= segment_index ? 0 : segment_index;
  const { carrier = {} } = segments[index] || {};
  return carrier.code || '';
};

export const bags_quantity_color = (quantity = 0, active_color = '#39414E') =>
  quantity > 0 ? active_color : '#AAAAAA';

// Boolean presence indicator (1 when the offer has any adult, else 0).
// Per-adult multiplication happens on the sidebar resume row.
export const hand_bags_per_adult = (flight_offer) =>
  count_adults(flight_offer) > 0 ? 1 : 0;

/**
 * Allowance the fare guarantees on every segment, so a per-leg split never
 * over-promises the worse leg. The least-generous-segment read is shared
 * with the fare card and the sidebar total.
 *
 * @param {object} flight_offer
 * @returns {number}
 */
export const luggage_bags_per_adult = (flight_offer) =>
  bag_quantity(
    guaranteed_bag_allowance(
      flight_offer,
      (fare_detail) => fare_detail.includedCheckedBags
    )
  );

export const cabin_bags_per_adult = (flight_offer) =>
  bag_quantity(
    guaranteed_bag_allowance(
      flight_offer,
      (fare_detail) => fare_detail.includedCabinBags
    )
  );
